<template>
  <div class="h-full flex flex-col overflow-y-hidden px-2 py-4 pb-14">
    <div class="flex items-center mb-4 space-x-2 w-full">
      <SearchBoxDummy @click="searchMenu" class="flex-1" />
      <div @click="downloadMenu">
        <img
          alt="image"
          class="h-10 p-1 border border-gray-200 shadow-sm rounded-md"
          src="@/assets/icons/menudownload.svg"
        />
      </div>
    </div>
    <div
      class="
        flex-1
        overflow-y-scroll
        grid grid-cols-2
        sm:grid-cols-3
        sm:gap-6
        gap-1
      "
    >
      <MenuType
        @click="viewMenu(item.category)"
        class="shadow-lg border-white border"
        v-for="(item, index) in menuTypes"
        :key="item"
        :index="index"
        :activeMenuTypeIndex="activeMenuTypeIndex"
        :title="item.title"
        :image="item.image"
      />
    </div>
  </div>
</template>

<script>
import MenuType from "@/views/menu/MenuType.vue";
import SearchBoxDummy from "@/views/menu/SearchBoxDummy.vue";
import { Toast } from "@capacitor/toast";
import { Browser } from "@capacitor/browser";
export default {
  components: { MenuType, SearchBoxDummy },
  created() {
    this.activeMenuInterval = setInterval(this.nextActiveMenuType, 3000);
  },
  unmounted() {
    clearInterval(this.activeMenuInterval);
  },
  data() {
    return {
      activeMenuTypeIndex: 0,
      activeMenuInterval: "",
      menuTypes: [
        {
          category: "Breakfast Options",
          title: "Breakfast",
          image: "img/menutypes/breakfast.jpg",
        },
        {
          category: "Burgers, Sandwiches, Subs",
          title: "Burgers, Sandwiches/Subs",
          image: "img/menutypes/burgers.jpg",
        },
        {
          category: "Children",
          title: "Children",
          image: "img/menutypes/kids.jpg",
        },
        {
          category: "Desserts",
          title: "Desserts",
          image: "img/menutypes/desserts.jpg",
        },
        {
          category: "Drinks",
          title: "Drinks",
          image: "img/menutypes/drinks.jpg",
        },
        {
          category: "Mains",
          title: "Mains",
          image: "img/menutypes/mains.jpg",
        },
        {
          category: "Pasta",
          title: "Pasta",
          image: "img/menutypes/pasta.jpg",
        },
        {
          category: "Pleasure Platters (Entree)",
          title: "Pleasure Platters (Entree)",
          image: "img/menutypes/pleasure.jpg",
        },
        {
          category: "Salads",
          title: "Salads",
          image: "img/menutypes/salads.jpg",
        },
        {
          category: "Sides",
          title: "Sides",
          image: "img/menutypes/sides.jpg",
        },
      ],
    };
  },
  methods: {
    nextActiveMenuType() {
      var next = this.$store.getters.randomInteger(0, this.menuTypes.length);
      this.activeMenuTypeIndex = next;
    },
    downloadMenu() {
      Toast.show({ text: "Downloading Menu...", position: "bottom" });
      var url = this.$store.state.appDetails?.menuLink?.link;
      Browser.open({ url, toolbarColor: "#af803e" });
    },
    viewMenu(category) {
      this.$router.push({
        name: "MenuByType",
        params: { category: category },
      });
    },
    searchMenu() {
      this.$router.push({ name: "MenuSearch" });
    },
  },
};
</script>
